import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Bars = createSvgIcon(
  () => (
    <path d="M1.5625 7.03125H42.1875C42.9688 7.03125 43.75 6.34766 43.75 5.46875V1.5625C43.75 0.78125 42.9688 0 42.1875 0H1.5625C0.683594 0 0 0.78125 0 1.5625V5.46875C0 6.34766 0.683594 7.03125 1.5625 7.03125ZM1.5625 22.6562H42.1875C42.9688 22.6562 43.75 21.9727 43.75 21.0938V17.1875C43.75 16.4062 42.9688 15.625 42.1875 15.625H1.5625C0.683594 15.625 0 16.4062 0 17.1875V21.0938C0 21.9727 0.683594 22.6562 1.5625 22.6562ZM1.5625 38.2812H42.1875C42.9688 38.2812 43.75 37.5977 43.75 36.7188V32.8125C43.75 32.0312 42.9688 31.25 42.1875 31.25H1.5625C0.683594 31.25 0 32.0312 0 32.8125V36.7188C0 37.5977 0.683594 38.2812 1.5625 38.2812Z" />
  ),
  '0 0 44 39'
);
